module.exports = __webpack_public_path__ + "static/media/Sec-3_Content_ID_Mobile.8346b23a.png";